<template>
  <div>
    <h1>
      Formulario de eventos
    </h1>
		<div :class="typeMessage" role="alert" id="message-update" v-if="message != ''">
			{{message}}
		</div>

    <div class="row">
      <form ref="formGlobalEvent" v-if="globalEvent != null">

        <div class="col-sm-3 elements-form-global-event">
          <label class="control-label">Tipo*</label>
          <select v-model="globalEvent.global_event_type" id="global_event_type" class="form-control">
            <option v-for="type in types" :key="type.id" :value="type.id">{{type.name}}</option>
          </select>
        </div>

        <div class="col-sm-3 elements-form-global-event">
          <label class="control-label">Cover*</label>
          <input type="text" v-model="globalEvent.cover" id="global_event_cover" class="form-control">
        </div>

        <div class="col-sm-3 elements-form-global-event">
          <label class="control-label">Url*</label>
          <input type="text" v-model="globalEvent.url" id="global_event_url" class="form-control">
        </div>        

        <div class="col-sm-3 elements-form-global-event">
          <label class="control-label">Nombre*</label>
          <input type="text" v-model="globalEvent.name" id="global_event_name" class="form-control" maxlength="72">
        </div>                

        <div class="col-sm-12 elements-form-global-event">
          <label class="control-label">Descripción*</label>
          <textarea type="text" v-model="globalEvent.description" cols="30" rows="5" id="global_event_description" class="form-control" maxlength="118"></textarea>
        </div>                        

        <div class="col-sm-4 elements-form-global-event">
          <label class="control-label">Fecha*</label>
          <input type="datetime-local" v-model="globalEvent.event_date" id="global_event_event_date" class="form-control">
        </div>

        <div class="col-sm-4 elements-form-global-event">
          <label class="control-label">Visible desde*</label>
          <input type="datetime-local" v-model="globalEvent.date_start" id="start_date" class="form-control">        
        </div>            

        <div class="col-sm-4 elements-form-global-event">
          <label class="control-label">Visible hasta*</label>
          <input type="datetime-local" v-model="globalEvent.date_end" id="end_date" class="form-control">        
        </div>                    

      </form>
   
      </div>
    
      <div class="row row-btn">
        <div class="col-sm-12 text-right">
          <input type="button" id="btnGuardar" class="btn btn-primary" value="Guardar" @click="createUpdateContract()">
          <!-- <input type="button" id="btnGuardar" class="btn btn-primary" value="crear reglas" @click="createRules()">
          <input type="button" id="btnGuardar" class="btn btn-primary" value="obtener reglas" @click="getRules()"> -->
        </div>
      </div>

      <table class="table" id="table-products">
        <thead>
          <tr>
            <th>id</th>
            <th>Cover</th>
            <th>Nombre</th>
            <th>Descripción</th>
            <th>Asistentes</th>
            <th>Fecha</th>
            <th>Visible desde</th>
            <th>Visible hasta</th>
            <th>Editar</th>
            <th>Eliminar</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(globalEvent, index) in global_events" :key="index">
            <td>{{globalEvent.id}}</td>
            <td>
              <img class="img-event-table" :src="globalEvent.cover" alt="">
            </td>
            <td>
              <a :href="globalEvent.url">
                {{globalEvent.name}}
              </a>              
            </td>
            <td>{{globalEvent.description }}</td>
            <td align="center" style="cursor: pointer;">
              <template v-if="globalEvent.assistant_users_count > 0">                
                <a type="button" class="btn btn-primary people-svg" data-toggle="modal" data-target="#exampleModal" @click.prevent="assistant_users = globalEvent.assistant_users"/>
                <p>{{globalEvent.assistant_users_count}}</p>              
              </template>
              <template v-else>
                <a type="button" class="btn btn-primary people-svg"/>              
                <p>0</p>
              </template>
            </td>
            <td class="global-event-date">{{globalEvent.event_date | formatDate }}</td>
            <td class="global-event-date">{{globalEvent.date_start | formatDate }}</td>
            <td class="global-event-date">{{globalEvent.date_end | formatDate }}</td>
            <td>
              <a class="btn btn-success" @click.prevent="edit(globalEvent, index)" target="_blank" role="button">editar</a>
            </td>
            <td>
              <a class="btn btn-danger" @click.prevent="deleteEvent(globalEvent, index)" target="_blank" role="button">Eliminar</a>
            </td>
          </tr>				
        </tbody>						
      </table>

      <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Usuarios asistentes</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <table class="table" id="table-assistant-users">
                <thead>
                  <tr>
                    <th>id</th>
                    <th>email</th>
                    <th>Nombre</th>
                    <th>Cliente</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(users, index) in assistant_users" :key="index">
                    <td>{{users.id}}</td>
                    <td>{{users.email}}</td>
                    <td>{{users.first_name}} {{users.last_name}}</td>
                    <td>{{users.client.name}}</td>
                  </tr>				
                </tbody>						
              </table>              
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
            </div>
          </div>
        </div>
      </div>      
  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios';
  export default {
    props:['global_events'],
    data() {
      return {
        assistant_users: [],
        types: [
          { id: 1, name: 'Evento'},
          { id: 2, name: 'Encuesta'},
          { id: 3, name: 'Boletín'}
        ],
        token: '',
        message: '',
        typeMessage: '',        
        indexUpdate: null,
        globalEvent: null,
        globalEventDummie: {
          global_event_type: null,
          cover: '',
          url: '',
          name: '',
          description: '',
          event_date: '',
          date_start: '',
          date_end: ''
        }         
      }
    },
    methods: {
      edit (globalEvent, index) {
        globalEvent = this.formatDatesEvent(globalEvent)
        this.globalEvent = globalEvent
        this.indexUpdate = index
      },
      deleteEvent (globalEvent, index) {
        this.setCredentials()
        axios.delete(`/global_events/${globalEvent.id}`, { global_event: this.globalEvent}, {}).then(res=>{
          this.global_events.splice(index, 1)
          if (res.status == 200) {
            this.showMessage('Evento eliminardo', 'alert-success')          
          }        
        }, (err) => {
          this.showMessage('No se pudo eliminar el evento', 'alert-danger')
        })
      },      
      formatDatesEvent (globalEvent) {
        const attributes = ['event_date', 'date_start', 'date_end']
        attributes.forEach(attirbute => {
          if (globalEvent[attirbute] != null) {
            globalEvent[attirbute] = `${globalEvent[attirbute].split('.')[0]}`
          }          
        });        
        return globalEvent
      },     
      setCredentials(){
        axios.defaults.headers['x-csrf-token'] = this.token
        axios.defaults.headers.common['Accept'] = 'application/json';
        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
      },
      createUpdateContract() {
        this.setCredentials()
        if (this.globalEvent.id != null) {
          this.update()
        } else {
          this.create()
        }
      },
      // async createRules () {
      //   console.log('createRules')
      //   this.setCredentials()
      //   const request = await axios.post(`/api/v1/clients/130/create_default_rules`, { }, {})
      //   console.log(request)
      // },
      // async getRules () {
      //   console.log('getRules')
      //   this.setCredentials()
      //   const request = await axios.get(`/api/v1/clients/rules?client_id=130`, { }, {})
      //   console.log(request)
      // },      
      create() {
        axios.post(`/global_events`, { global_event: this.globalEvent}, {}).then(res=>{
          if (res.status == 201) {
            this.global_events.push(res.data.global_event)
            this.globalEvent = null
            this.globalEvent = this.globalEventDummie            
            this.showMessage('Evento creado', 'alert-success')          
          }        
        }, (err) => {
          this.showMessage('No se pudo crear evento', 'alert-danger')
        })
      },
      update() {
        axios.put(`/global_events/${this.globalEvent.id}`, { global_event: this.globalEvent}, {}).then(res=>{
          console.log('res')
          console.log(res)
          if (res.status == 200) {
            let globalEvent = res.data.global_event
            this.globalEvent = null
            this.globalEvent = this.globalEventDummie
            Vue.set(this.global_events, this.indexUpdate, globalEvent)
            this.showMessage('Evento actualizado', 'alert-success')          
          }        
        }, (err) => {
          this.showMessage('No se pudo actualizar el evento', 'alert-warning')
        })      
      },
      showMessage(message, typeMessage){
        this.message = message
        this.typeMessage = `alert ${typeMessage}`
        setTimeout(() => this.message = '', 3000)
      },      
    },
    created () {
      this.globalEvent = this.globalEventDummie
      this.token = document.querySelector('meta[name="csrf-token"]').getAttribute('content')    
    },
    filters: {
      formatDate: function(value) {
        if (value != null) {
          return `Fecha: ${value.split('T')[0]}. Hora: ${value.split('T')[1].split(".")[0]}`
        } else {
          return 'Sin fecha'
        }
        
      }
    }
  }
</script>

<style scoped>

</style>